<template>
	<div class="order-copy pop_white-s pop_bege popup_wrap" style="display:block">
		<div class="popup_in">
			<div class="popup">
				<div class="corner-top"></div>
				<div class="exists_icon">
					<LOGO />
				</div>
				<div class="pop_frame">
					<h2 class="title25" style="margin-top:15px;">
						אחלה בחירה!
						<!-- <span style="" class="oftenProduct"  v-html="product.name"></span> -->
					</h2>
					<div class="text">איך לטחון לך?</div>
					<ul>
						<li v-for="option in options" :key="option.uid">
							<button
								:class="{selected : option.uid === selected_option }"
								:data-uid="option.uid"
								@click.prevent="selectOption($event)"
							>
								{{option.name}}
							</button>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import close from "../../assets/img/close.svg";
	import LOGO from "../../assets/img/carmella.svg";
	import { mapActions } from "vuex";
	export default {
		props: [ "product" ],
		data() {
			return {
				selected_option: null,
				options: [/*{
					uid: 'grinding_level_1',
					name: 'לא טחון (פולים שלמים)',
					value: 'דרגת טחינה 0: לא טחון (פולים שלמים)'
				},*/{
					uid: 'grinding_level_2',
					name: 'טורקי/שחור',
					value: 'דרגת טחינה 1: טורקי/שחור'
				},{
					uid: 'grinding_level_3',
					name: 'מכונת אספרסו',
					value: 'דרגת טחינה 2: מכונת אספרסו'
				},{
					uid: 'grinding_level_4',
					name: 'מקינטה',
					value: 'דרגת טחינה 3: מקינטה'
				},{
					uid: 'grinding_level_5',
					name: 'פילטר',
					value: 'דרגת טחינה 5: פילטר'
				}]
			};
		},
		methods: {
			...mapActions(["getProductById", "updateCart", "clarCart"]),
			selectOption(e){
				this.selected_option = e.target.getAttribute('data-uid');
				this.product.selected_grinding_level = this.options.find( o => o.uid === this.selected_option );
				this.product.note = this.product.selected_grinding_level.value;
				this.updateCart([this.product]);
				this.closePopup();
			},
			closePopup() {
				this.$modal.hide("GrindingLevels");
			}
		},
		components: {
			LOGO,
		}
	};
</script>

<style lang="sass" scoped>

	ul
		margin-top: 1.5rem
		li
			list-style-type: none
			text-align: center
			margin-bottom: 7px
			&:before
				display: none
		button
			display: block
			margin: 0 auto
			display: block
			margin: 0 auto
			padding: 0.5rem 1rem
			background: #ffffff
			color: #000000
			border: 2px solid #767676
			outline: none
			border-radius: 2rem
			width: 13rem
			text-align: center
			&:hover, &:focus
				background: #e9fff3
			&.selected
				background: #1e824c
				color: #ffffff
				border: 2px solid #1e824c
				&:hover, &:focus
					background: #1e824c

</style>
